import View from "components/View";
const Text = View;
export default Text;
